import BaseApi from 'common/apiRequest/apis/BaseApi';
import { Request } from '../apiConcentrator';
import APINames from '../APINames';

class AccountsApi extends BaseApi {
  public requestInstance = new Request(APINames.ACCOUNTS);
}
export default new AccountsApi();
